<template>
  <div class="contact-page">
    <!-- 一级标题 -->
    <h1 class="section-title">{{ t('contactPage.title') }}</h1>
    <!-- 二级标题 -->
    <h2 class="sub-title" id="cooperation">{{ t('contactPage.cooperationTitle') }}</h2>

    <!-- 三个横向并排的容器（黑色背景） -->
    <div class="contact-bg">
      <div class="contact-container single">
        <!-- 中国总部 -->
        <div class="contact-card">
          <h3 class="card-title">{{ t('contactPage.cnCardTitle') }}</h3>
          <div class="card-content">
            <p><strong>{{ t('contactPage.company') }}</strong></p>
            <p>{{ t('contactPage.addressLabel') }}: {{ t('contactPage.cnAddress') }}</p>
            <p>{{ t('contactPage.phoneLabelSimple') }}: {{ t('contactPage.cnPhone') }}</p>
            <p>{{ t('contactPage.emailLabel') }}: {{ t('contactPage.cnEmail') }}</p>
          </div>
        </div>

        <!-- 全球总部 / Global Offices（马来西亚） -->
        <div class="contact-card">
          <h3 class="card-title">{{ t('contactPage.hqCardTitle') }}</h3>
          <div class="card-content">
            <p><strong>{{ t('contactPage.company') }}</strong></p>
            <p>
              {{ t('contactPage.addressLabel') }}: {{ t('contactPage.address') }}
            </p>
            <p>{{ t('contactPage.emailLabel') }}: {{ t('contactPage.email') }}</p>
            <p>{{ t('contactPage.workHours') }}</p>
          </div>
        </div>

        <!-- 香港总部 -->
        <div class="contact-card">
          <h3 class="card-title">{{ t('contactPage.hkCardTitle') }}</h3>
          <div class="card-content">
            <p><strong>{{ t('contactPage.company') }}</strong></p>
            <p>{{ t('contactPage.addressLabel') }}: {{ t('contactPage.hkAddress') }}</p>
            <p>{{ t('contactPage.phoneLabelSimple') }}: {{ t('contactPage.hkPhone') }}</p>
            <p>{{ t('contactPage.emailLabel') }}: {{ t('contactPage.hkEmail') }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 投诉与建议（风格区分卡片） -->
    <div class="contact-bg">
      <div class="contact-container single">
        <div class="suggest-card">
          <h3 class="suggest-title">{{ t('contactPage.complaintTitle') }}</h3>
          <div class="suggest-content">
            <p>{{ t('contactPage.complaintText') }}</p>
            <p>
              📧 <a href="mailto:Yongcai@petalmail.com" class="email-link">Yongcai@petalmail.com</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script setup>
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
</script>

<style scoped>
.contact-page {
  max-width: 100%;
  background-color: #000; /* 添加这行 */
  color: #fff;
  padding: 40px 0 60px; /* 添加适当的上内边距 */
}

.section-title {
  text-align: center;
  font-size: 32px;
  margin-bottom: 20px;
  color: #f39c12;
  border-bottom: 2px solid #f39c12; /* 金色底边框 */
  padding-bottom: 10px;
  display: inline-block;
  margin-left: 50%;
  transform: translateX(-50%);
}

.sub-title {
  text-align: center;
  font-size: 24px;
  margin-bottom: 20px;
  color: #f39c12; /* 金色 */
}
.join-title {
  color: #f39c12; /* 金色文字 */
  text-align: center;
  font-size: 24px;
  margin: 40px auto 20px; /* 上边距40px，下边距20px */
  padding-bottom: 10px;
  position: relative; /* 为伪元素定位做准备 */
  display: inline-block; /* 使下划线长度随内容宽度变化 */
  background-color: #000;
}

/* 使用伪元素创建自定义下划线 */
.join-title::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%; /* 从中间开始 */
  transform: translateX(-50%); /* 居中 */
  width: 80%; /* 控制下划线长度为标题宽度的80% */
  height: 2px; /* 下划线粗细 */
  background-color: #f39c12; /* 金色下划线 */
}

/* 新增的黑色背景容器 */
.contact-bg {
  width: 100%;
  background-color: #000;
  padding: 20px 0; /* 上下内边距 */
}

.contact-container {
  display: flex;
  justify-content: space-between;
  gap: 30px;
  flex-wrap: wrap;
  max-width: 90%;
  margin: 0 auto;
  padding: 0 20px;
}
.contact-container.single {
  flex-direction: column; /* 纵向排列 */
  justify-content: flex-start;
  align-items: stretch;
  gap: 20px;
  max-width: 900px; /* 单列阅读宽度更舒适 */
}
.contact-container.single .contact-card { flex: 1 1 100%; min-width: 100%; }

.contact-card {
  flex: 1 1 30%; /* 更精确的宽度控制 */
  min-width: 280px; /* 更小的最小宽度 */
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  border: 1px solid rgba(241, 196, 15, 0.3);
  padding: 20px; /* 减小内边距 */
  transition: all 0.3s ease;
  color: #fff;
}

.contact-card:hover {
  transform: translateY(-5px);
  background: rgba(255, 255, 255, 0.15);
  border-color: #f39c12;
  box-shadow: 0 10px 20px rgba(241, 196, 15, 0.1);
}

.card-title {
  font-size: 20px;
  color: #f39c12; /* 金色 */
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(241, 196, 15, 0.3);
}

.card-content {
  line-height: 1.8;
}

.card-content p {
  margin-bottom: 12px;
}

.card-content strong {
  color: #f39c12; /* 金色强调 */
}
/* 区分样式的投诉/建议卡片 */
.suggest-card {
  background: #111;
  border: 1px solid #444;
  border-left: 4px solid #f39c12;
  color: #fff;
  border-radius: 8px;
  padding: 20px;
}
.suggest-title {
  font-size: 20px;
  margin-bottom: 12px;
  color: #fff;
}
.suggest-content { line-height: 1.8; }
.recruit-list {
  padding-left: 20px;
  margin-bottom: 16px;
}
.recruit-list li {
  list-style: disc;
  margin-bottom: 8px;
  font-size: 15px;
}

.email-link,
.phone-link {
  color: #f39c12;
  text-decoration: underline;
  word-break: break-all;
}
.email-link:hover,
.phone-link:hover {
  color: #fff;
  text-decoration: none;
}

/* 响应式设计 */
@media (max-width: 1024px) {
  /* 平板设备 */
  .contact-container {
    max-width: 95%; /* 增加容器宽度占比 */
    gap: 20px; /* 减小卡片间距 */
  }

  .contact-card {
    padding: 15px; /* 减小内边距 */
  }

  .card-title {
    font-size: 18px; /* 调小标题字号 */
    margin-bottom: 15px;
  }

  .card-content p {
    font-size: 14px; /* 调小正文字号 */
    line-height: 1.6;
  }
}

@media (max-width: 768px) {
  /* 小尺寸平板 */
  .section-title {
    font-size: 28px;
    margin-bottom: 15px;
  }

  .sub-title {
    font-size: 20px;
    margin-bottom: 15px;
  }

  .contact-bg {
    padding: 15px 0; /* 调整背景容器内边距 */
  }

  .contact-container {
    flex-wrap: wrap; /* 允许换行 */
  }

  .contact-card {
    flex: 1 1 45%; /* 两列布局 */
    min-width: 45%; /* 确保两列显示 */
  }
}

@media (max-width: 480px) {
  /* 移动设备 */
  .section-title {
    font-size: 24px;
    padding-bottom: 8px;
    border-bottom-width: 1px;
  }

  .sub-title {
    font-size: 18px;
  }

  .contact-container {
    flex-direction: column;
    gap: 15px;
    padding: 0 15px;
  }

  .contact-card {
    flex: 1 1 100%; /* 单列布局 */
    min-width: 100%;
    padding: 15px;
  }

  .card-title {
    font-size: 16px;
  }

  .card-content p {
    font-size: 13px;
  }
}
</style>
